export default function DTD_Entities() {
  return (
    <div>
      <h1>DTD_Entities</h1>
      <p>This is the DTD_Entities component.</p>
    </div>
  );
}